import * as localeKo from "./ko";
import * as localeEn from "./en";

const ko = { ...localeKo };
const en = { ...localeEn };

export { ko, en };
